export default __webpack_public_path__ + "static/media/hall-of-fame-icon-website.77b5d0b5.svg";